import { render, staticRenderFns } from "./MyOverlay.vue?vue&type=template&id=6856ab33&scoped=true&"
import script from "./MyOverlay.vue?vue&type=script&lang=js&"
export * from "./MyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MyOverlay.vue?vue&type=style&index=0&id=6856ab33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6856ab33",
  null
  
)

export default component.exports